import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, MessageCircle, ChevronRight } from "lucide-react";
import Navbar from "../Landing/Navbar";
import Footer from "./Footer";

const LegalPage = ({ title, subtitle, Icon, lastUpdated, children }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="page-container max-w-4xl pt-4 pb-app-nav sm:pt-7 lg:pt-10">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-5 sm:mb-7"
        >
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="mb-5 inline-flex min-h-9 items-center gap-1.5 rounded-full border border-sand-200 bg-white px-3.5 text-[12px] font-semibold text-ink-600 transition hover:border-brand-200 hover:text-brand-700"
          >
            <ArrowLeft size={14} /> Back
          </button>

          <div className="flex items-start gap-3.5">
            {Icon && (
              <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-brand-50 text-brand-700">
                <Icon size={20} />
              </span>
            )}
            <div className="min-w-0">
              <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-700">
                Karanki Matrimony · Legal
              </p>
              <h1 className="mt-1 font-display text-[26px] font-bold leading-tight text-ink-800 sm:text-3xl">
                {title}
              </h1>
              {subtitle && (
                <p className="mt-2 max-w-2xl text-[13px] leading-5 text-ink-500 sm:text-[14px] sm:leading-6">
                  {subtitle}
                </p>
              )}
              {lastUpdated && (
                <p className="mt-3 text-[11px] font-medium text-ink-400">
                  Last updated {lastUpdated}
                </p>
              )}
            </div>
          </div>
        </motion.div>

        <motion.article
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
          className="px-1 py-1 sm:px-2"
        >
          <div className="legal-document max-w-none">
            {children}
          </div>
        </motion.article>

        {/* Contact strip */}
        <div className="mt-4 flex flex-col items-start gap-4 rounded-3xl border border-brand-100 bg-brand-50/60 p-4 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-brand-700">
              <MessageCircle size={17} />
            </span>
            <div>
              <p className="text-[13px] font-semibold text-ink-800">Have a question?</p>
              <p className="text-[12px] text-ink-500">Our team is ready to help you.</p>
            </div>
          </div>
          <Link
            to="/contact-us"
            className="inline-flex min-h-10 items-center gap-2 rounded-xl bg-brand-700 px-4 text-[12px] font-semibold text-white transition hover:bg-brand-800"
          >
            Contact us <ChevronRight size={15} />
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LegalPage;
